import { Mark, mergeAttributes, Node } from '@tiptap/core';

export const SvgNode = Node.create({
  name: 'svgNode',
  group: 'inline',
  atom: true,
  inline: true,

  parseHTML() {
    return [
      {
        tag: 'span[data-svg-node]',
      },
    ];
  },

  addAttributes() {
    return {
      svg: {
        default: null,
        parseHTML: element => {
          return element.innerHTML;
        },
        renderHTML: attributes => {
          if (!attributes.svg) {
            return {};
          }

          return {
            'data-svg': attributes.svg,
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-svg-node': '',
      }),
    ];
  },

  addNodeView() {
    return ({ node }) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('svg-node');
      wrapper.innerHTML = node.attrs.svg;
      return {
        dom: wrapper,
      };
    };
  },
});

export const SlashCommandGroupTitleMark = Mark.create({
  name: 'slashCommandGroupTitle',
  group: 'inline',

  parseHTML() {
    return [
      {
        tag: 'span[data-type="slash-command-group-title"]',
      },
    ];
  },

  addOptions() {
    return {
      type: 'slashCommandGroupTitle',
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-type': 'slash-command-group-title',
      },
      0,
    ];
  },
});

export const CustomNode = Node.create({
  name: 'custom',
  group: 'inline',
  inline: true,
  selectable: true,
  atom: true,
  // priority: 102,

  content: 'inline*',

  marks: 'slashCommandGroupTitle',

  parseHTML() {
    return [
      {
        tag: 'span[data-type="slash-command"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        ...HTMLAttributes,
        'data-type': 'slash-command',
        contenteditable: 'false',
      },
      0,
    ];
  },
});

export const slashExtensionNodes = [
  SvgNode,
  SlashCommandGroupTitleMark,
  CustomNode,
];
